
import http from "../core/http";

const group = 'auth';

export const checkAuthRequest =  async () => {
    return await http.get(`${group}/me`).then(res => res.data).catch(error => ({"status":0, "message":error.message}));
}

export const tokenRefreshRequest =  async () => {
    return await http.get(`${group}/refresh`).then(res => res.data).catch(error => ({"status":0, "message":error.message}));
}

export const logoutRequest =  async () => {
    return await http.post(`${group}/logout`).then(res => res.data).catch(error => ({"status":0, "message":error.message}));
}



export const changePasswordRequest =  async (data) => {
    return await http.post(`${group}/password/change`, data).then(res => res.data).catch(http.defaultCatch);
}
